import React, { useEffect, useState } from 'react'
import Header from '../Components/Header'
import { Avatar, Box, Button, Container, Icon, IconButton, Typography } from '@mui/material'
import image from "../LogoFont.png"
import Footer from '../Components/Footer'
import illustation from "../Files/ImageAPropos.png"
import photo from "../PXL_20231009_125631885.jpg"
import Project from '../Components/Project'
import { LinkedIn, GitHub, Instagram, Facebook, Mail, Description, FormatQuote, ArrowRight, ArrowLeft, Padding, Opacity } from '@mui/icons-material'
import cover from "../cover1.jpg";
import image18 from "../Files/image 18.png";
import cover1 from "../Files/2149901780.jpg";
import detaille1 from "../Files/Detaille1.svg";
import detaille2 from "../Files/Detaille2.svg";
import detaille3 from "../Files/Detaille3.svg";
import ellipse1 from "../Files/ellipse1.svg";
import ellipse2 from "../Files/ellipse2.svg";

import ellipse3 from "../Files/ellipse3.svg";
import ellipse4 from "../Files/ellipse4.svg";
import ellipse5 from "../Files/ellipse5.svg";
import ellipse6 from "../Files/ellipse6.svg";
import ellipse7 from "../Files/ellipse7.svg";
import focusiaimage from "../Files/focusaiimage.png";

import conseil from "../Files/conseil.jpg";
import md from "../Files/md.jpg";
import dev from "../Files/dev.jpg";
import infogerence from "../Files/infogerence.svg";
import tn from "../Files/tn.jpg";

import ebcall from "../Files/ebcall.png";
import ebmarket from "../Files/ebmarket.jpg";
import loanflex from "../Files/loanflex.jpg";




import cover2 from "../2.jpg";
import cover3 from "../3.jpg";
import cover4 from "../4.jpg";
import { useTranslation } from 'react-i18next'
import SocialLink from '../Components/SocialLink'
import Services from "../Data/Services.json";
import Produits from "../Data/Produits.json"
import Cible from "../Data/Cible.json";
import Realisations from "../Data/Realisation.json";
import Contact from '../Components/Contact'
import { Carousel } from 'antd'
import { useNavigate } from 'react-router-dom'
import { Variants, motion } from 'framer-motion'
import zero from '../african-american-worker-standing-uniform-wearing-safety-hat-factory.jpg'
import un from '../steel-bar-site-construction.jpg'
import deux from '../construction-engineer.jpg'

import banqueImage from "../Files/569 (1).jpg"
import microfinanceImage from "../Files/537.jpg"
import cooperativeImage from "../Files/coop.jpg"
import pmeImage from "../Files/pme.jpg"
import TopHeader from '../Components/TopHeader'
import TitrePartie from '../Components/TitrePartie'
import ElementCaroucel from '../Components/ElementCaroucel'
import i18next from 'i18next'
import logoImage from "../Files/IBG Logo without background.svg";
import TitrePage from './TitrePage'


interface Props { }

function Home(props: Props) {
    const { } = props
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()

    const scroll: Variants = {
        offscreen: {
            y: 15,
            opacity: .5
        },
        onscreen: {
            y: 10,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };
    const settings = {
        nextArrow: <ArrowRight />,
        prevArrow: <ArrowLeft />
    }

    const [currentSlide, setCurrentSlide] = useState(1);
    const handleChangeSlide = (to: any) => {
        setCurrentSlide(to);
    };

    useEffect(() => {
        setTimeout(() => {
            if (currentSlide == Produits.length-1) {
                setCurrentSlide(0)
            } else {
                setCurrentSlide(currentSlide + 1)
            }
        }, 2000);
    })

    return (
        <div style={{ backgroundColor: "inherit" }} >
            <TitrePage keyWords={"titrePage.accueil.keywords"} lien='/Root' pageDescription={"titrePage.accueil.descriptionPage"} titre='accueil' hiddeTitle  />
            <TopHeader />
            <Header /><br />

            <Carousel style={{ marginTop: "25px" }} vertical={false} effect='fade' autoplay dotPosition='top'>
                <Box sx={{ display: { xs: 'none', md: 'block' }, mr: 1 }}>
                    <Box bgcolor={"#000154"} sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <Box sx={{ width: { xs: '100%', md: '50%' } }}>
                            <img draggable={false}  width={"100%"} src={cover1} alt="" />
                            <img draggable={false} style={{ left: "45%", marginTop: "-4.8%", position: "absolute" }} className='cover anim-img' width={"5%"} src={detaille1} alt="" />
                        </Box>
                        <Box sx={{ width: { xs: '100%', md: '50%' } }}>

                            <img draggable={false} style={{ marginTop: "-3%", position: "absolute" }} className='cover anim-img' src={ellipse1} alt="" />
                            <img draggable={false} style={{ left: "83%", marginTop: "18%", position: "absolute" }} className='cover anim-img' src={ellipse2} alt="" />
                            <Box textAlign={"left"} color={"white"} padding={"15%"}>
                                <motion.div
                                    initial="offscreen"
                                    whileInView="onscreen"
                                    viewport={{ once: false, amount: 0.8 }}
                                    variants={scroll}
                                >
                                    <Typography fontWeight={"bold"} variant='h4'>{t("Texte.Banniere.titre")}</Typography>
                                </motion.div>

                                <br />
                                <motion.div
                                    initial="offscreen"
                                    whileInView="onscreen"
                                    viewport={{ once: false, amount: 0.8 }}
                                    variants={scroll}
                                >
                                    <label>{t("Texte.Banniere.contenu")}</label>
                                </motion.div>

                                <br /><br />
                                <button className='btn1'>{t("Label.Titre.titre9")}</button>
                            </Box>
                        </Box>
                    </Box>
                </Box>

            </Carousel>

            <Container style={{ height: '100%', }} className='conatainer'>
                <br />

                <img draggable={false} style={{ left: "6%", marginTop: "10%", position: "absolute" }} className='cover anim-img' width={"10%"} src={ellipse6} alt="" />
                <TitrePartie titre={t("Texte.Accueil.Partie1.titre")} />
                <Box sx={{ display: { xs: 'block', md: 'flex' } }} gap={10}>

                    <Box id='about' className={"text"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                        >
                            <label style={{ fontWeight: 'lighter' }} htmlFor="">
                                <Typography fontWeight={"bold"} variant='h5' textAlign={"left"} >
                                    {t("Texte.Accueil.Partie1.sousTitre")}
                                </Typography><br />
                                <Typography textAlign={"justify"} >
                                    {t("Texte.Accueil.Partie1.contenu")}
                                    <br />
                                    <br />
                                    <button onClick={(event) => {
                                        const anchor = (
                                            (event.target as HTMLDivElement).ownerDocument || document
                                        ).querySelector('#back-to-top-anchor');

                                        if (anchor) {
                                            anchor.scrollIntoView({
                                                block: 'center',
                                            });
                                        };
                                        navigate("/")
                                    }} className='btn'>{t("Label.Titre.titre9")}</button>
                                </Typography>
                            </label>
                        </motion.div>

                    </Box>
                    <Box>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                        ><img draggable={false} className='ill' src={illustation} alt="" /></motion.div>
                    </Box>

                </Box>
            </Container>
            <br />

            <Box className="boxColorDGradiant" >
                <Container><br />

                    <img draggable={false} style={{ left: "85%", marginTop: "-4%", position: "absolute" }} className='cover anim-img' width={"15%"} src={ellipse3} alt="" />
                    <img draggable={false} style={{ left: "1%", marginTop: "23%", position: "absolute" }} className='cover anim-img' width={"15%"} src={ellipse4} alt="" />
                    <TitrePartie titre={t("Texte.Accueil.Partie2.titre")} /><br />
                    <Typography fontWeight={"lighter"} textAlign={"left"}>{t("Texte.Accueil.Partie2.sousTitre")}</Typography>
                    <br />

                    <Box display={{ xs: "none", md: "block" }}>
                        <Carousel
                            arrows {...settings}
                            centerMode swipeToSlide slidesToShow={3} effect='scrollx' dotPosition='bottom'>
                            {Cible.map((f, index) => (
                                <Project withBackground fullWidthImage gap showBtn logo={
                                    index.toString() == '0' ? banqueImage :
                                        index.toString() == '1' ? microfinanceImage :
                                            index.toString() == '2' ? cooperativeImage :
                                                pmeImage
                                } link={f.link} linkName={f.title} date={f.date.split("|")[0]} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />

                            ))}
                        </Carousel>
                    </Box>

                    <Box display={{ xs: "block", md: "none" }}>
                        <Carousel slidesToShow={1} effect='scrollx' autoplay dotPosition='bottom'>
                            {Cible.map((f, index) => (
                                <Project withBackground showBtn logo={
                                    index.toString() == '0' ? banqueImage :
                                        index.toString() == '1' ? microfinanceImage :

                                            index.toString() == '2' ? cooperativeImage :
                                                pmeImage
                                } link={f.link} linkName={f.title} date={f.date.split("|")[0]} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />
                            ))}
                        </Carousel>
                    </Box>


                </Container>
            </Box><br />
            <Container id='products' ><br />
                <TitrePartie titre={t("Texte.Accueil.Partie3.titre")} /><br />
                <Typography fontWeight={"lighter"} textAlign={"left"}>{t("Texte.Accueil.Partie3.sousTitre")}</Typography>

                <Box display={{ xs: "none", md: "block" }}>

                    <img draggable={false} style={{ right: "10%", marginTop: "23%", position: "absolute", opacity: ".2" }} className='cover anim-img' width={"13%"} src={ellipse5} alt="" />
                    <Box display={"flex"}>
                        {Produits.map((f, index) => (
                            <div
                                // onClick={() => { handleChangeSlide(index) }}
                                style={{ width: "100%" }}
                                key={index}
                                className={`carousel-item ${index === currentSlide ? "active" : ""
                                    }`}
                            >
                                <Project fullWidthImage showBtn logo={
                                    index.toString() == '0' ? ebcall :
                                        index.toString() == '1' ? ebmarket :
                                            loanflex
                                } link={f.link} linkName={f.title} date={f.date.split("|")[0]} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />

                            </div>
                        ))}

                    </Box>
                    <br />
                </Box>
                <Box display={{ xs: "block", md: "none" }}>

                    <img draggable={false} style={{ right: "10%", marginTop: "23%", position: "absolute" }} className='cover anim-img' width={"13%"} src={ellipse5} alt="" />

                    {Produits.map((f, index) => (
                        <Project fullWidthImage showBtn logo={
                            index.toString() == '0' ? ebcall :
                                index.toString() == '1' ? ebmarket :
                                    loanflex
                        } link={f.link} linkName={f.title} date={f.date.split("|")[0]} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />

                    ))}
                </Box>
            </Container>

            <Box className="boxColor1" >
                <Container><br />

                    <img draggable={false} style={{ left: "85%", marginTop: "-4%", position: "absolute" }} className='cover anim-img' width={"15%"} src={ellipse3} alt="" />
                    <img draggable={false} style={{ left: "1%", marginTop: "23%", position: "absolute" }} className='cover anim-img' width={"15%"} src={ellipse4} alt="" />
                    <TitrePartie titre={t("Texte.Accueil.Partie4.titre")} whithFont /><br />
                    <Typography fontWeight={"lighter"} color={"white"} textAlign={"left"}>{t("Texte.Accueil.Partie4.sousTitre")}</Typography>
                    <br />
                    <Box sx={{ display: { xs: 'block', md: 'flex' } }} gap={10}>

                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll}
                            ><img draggable={false} width={"100%"} src={image18} alt="" /></motion.div>
                        </Box>
                        <Box sx={{ width: { xs: 'none', md: '50%' } }} id='about' className={"text"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll}
                            >
                                <label style={{ fontWeight: 'lighter' }} htmlFor="">
                                    <Typography color={"white"} variant='h5' textAlign={"left"} >
                                        {t("Texte.Accueil.Partie4.titre2")}
                                    </Typography><br />
                                    <Typography color={"white"} textAlign={"justify"} >
                                        {t("Texte.Accueil.Partie4.contenu")}
                                        <br />
                                        <br />
                                        <button onClick={(event) => {
                                            const anchor = (
                                                (event.target as HTMLDivElement).ownerDocument || document
                                            ).querySelector('#back-to-top-anchor');

                                            if (anchor) {
                                                anchor.scrollIntoView({
                                                    block: 'center',
                                                });
                                            };
                                            navigate("/")
                                        }} className='btn'>{t("Label.Titre.titre9")}</button>
                                    </Typography>
                                </label>
                            </motion.div>

                        </Box>
                    </Box>
                    <br /><br />
                </Container>
            </Box><br />
            <Container id='services'>

                <TitrePartie titre={t("Texte.Accueil.Partie8.titre")} /><br />
                <Typography fontWeight={"lighter"} textAlign={"left"}>{t("Texte.Accueil.Partie8.sousTitre")}</Typography>


                <Box padding={"1%"} display={{ xs: "none", md: "block" }}>
                    <Carousel
                        arrows {...settings}
                        style={{ padding: "0px" }}
                        centerMode swipeToSlide slidesToShow={3} effect='scrollx' dotPosition='bottom'>
                        {Services.map((f, index) => (
                            <Project withBackground boxShadow gap showBtn logo={
                                index.toString() == '0' ? tn :
                                    index.toString() == '1' ? dev :
                                        index.toString() == '2' ? infogerence :
                                            index.toString() == '3' ? md :
                                                conseil
                            } link={f.link} linkName={f.title} date={f.date.split("|")[0]} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />

                        ))}
                    </Carousel>
                </Box>

                <Box display={{ xs: "block", md: "none" }}>
                    <Carousel slidesToShow={1} effect='scrollx' autoplay dotPosition='bottom'>
                        {Services.map((f, index) => (
                            <Project withBackground showBtn logo={
                                index.toString() == '0' ? tn :
                                    index.toString() == '1' ? dev :
                                        index.toString() == '2' ? infogerence :
                                            index.toString() == '3' ? md :
                                                conseil
                            } link={f.link} linkName={f.title} date={f.date.split("|")[0]} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />
                        ))}
                    </Carousel>
                </Box>
            </Container>
            <br />


            <Container style={{ borderTop: "1px solid" }}><br />

                {/* <img draggable={false} style={{ left: "10%", marginTop: "25%", position: "absolute" }} className='cover anim-img' width={"10%"} src={ellipse7} alt="" /> */}
                <TitrePartie titre={t("Texte.Accueil.Partie10.titre")} /><br />
                <br />
                <Box sx={{ display: { xs: 'block', md: 'flex' } }} gap={10}>

                    <Box id='about' className={"text"} sx={{ width: { xs: 'none', md: '50%' } }}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                        >
                            <label style={{ fontWeight: 'lighter' }} htmlFor="">
                                <Typography fontWeight={"bold"} variant='h5' textAlign={"right"} >
                                    {t("Texte.Accueil.Partie10.sousTitre")}
                                </Typography><br />
                                <Typography textAlign={"right"} >
                                    {t("Texte.Accueil.Partie10.contenu")}
                                    <br />
                                    <br />
                                    <button onClick={(event) => {
                                        const anchor = (
                                            (event.target as HTMLDivElement).ownerDocument || document
                                        ).querySelector('#back-to-top-anchor');

                                        if (anchor) {
                                            anchor.scrollIntoView({
                                                block: 'center',
                                            });
                                        };
                                        navigate("/")
                                    }} className='btn'>{t("Label.Titre.titre9")}</button>
                                </Typography>
                            </label>
                        </motion.div>

                    </Box>

                    <Box>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                        ><img width={"100%"} draggable={false} src={focusiaimage} alt="" /></motion.div>
                    </Box>
                </Box>
                <br />
                <br />
            </Container>
            {/* <Box className='boxColorDGradiant'>

                <Container>
                    <br />
                    <TitrePartie titre='Nos Statistiques' />
                    <Box sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                            style={{ padding: "3%", width: "100%", height: "100%" }}
                        ><div style={{ borderRadius: "100%", padding: "2%" }}>
                                <Typography fontWeight={"bold"} variant='h5'>+15</Typography>
                                <label htmlFor="">Employés</label>
                            </div></motion.div>

                        <hr />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                            style={{ padding: "3%", width: "100%", height: "100%" }}
                        ><div style={{ borderRadius: "100%", padding: "2%" }}>
                                <Typography fontWeight={"bold"} variant='h5'>+30</Typography>
                                <label htmlFor="">Projets réalisé</label>
                            </div></motion.div>

                        <hr />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                            style={{ padding: "3%", width: "100%", height: "100%" }}
                        > <div style={{ borderRadius: "100%", padding: "2%" }}>
                                <Typography fontWeight={"bold"} variant='h5'>+11</Typography>
                                <label htmlFor="">Pays solicités</label>
                            </div></motion.div>

                        <hr />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                            style={{ padding: "3%", width: "100%", height: "100%" }}
                        ><div style={{ borderRadius: "100%", padding: "2%" }}>
                                <Typography fontWeight={"bold"} variant='h5'>+110</Typography>
                                <label htmlFor="">Clients</label>
                            </div></motion.div>

                    </Box>
                </Container>
            </Box> */}
            {/* <Box >
                <Container><br />
                    <Typography fontFamily={"sans-serif"} variant='h4' style={{ padding: "3px", fontWeight: "bold", textAlign: "center" }}>Nos Réalisations</Typography>
                    Découvrez quelques-uns de nos projets emblématiques qui témoignent de notre savoir-faire et de notre engagement.
                    <hr />
                    <Box gap={5} sx={{ display: { xs: 'block', md: 'flex' }, mr: 1 }}>
                        {Realisations.map((f, index) => (
                            index == 0 || index == 1 || index == 2 ? <Project showBtn logo={
                                index.toString() == '0' ? zero :
                                    index.toString() == '1' ? un :
                                        deux
                            } link={f.link} linkName={f.title} date={f.date.split("|")[0]} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language=="fr"?0:1]} /> : ""
                        ))}
                    </Box>
                </Container>
                <br />
            </Box> */}

            <Box>
                <Container>
                    <img draggable={false} style={{ left: "0%", position: "absolute" }} width={"100%"} className='cover anim-img' src={detaille3} alt="" />
                    <TitrePartie titre={t("Texte.Accueil.Partie9.titre")} />
                    <br />
                    <Typography fontWeight={"lighter"} textAlign={"left"}>{t("Texte.Accueil.Partie9.sousTitre")} </Typography>
                    <br />
                    <Contact />
                </Container>
                <br /><br />
            </Box>
            <Footer />
        </div>
    )
}

export default Home